var ShopifySettings = {};

document.addEventListener('DOMContentLoaded', function() {
  init();
});

function init() {
  if (typeof window.theme === 'undefined' || typeof window.theme.settings === 'undefined') {
    console.error('Shopify theme settings (window.theme.settings) are not defined. Make sure your Liquid file exposes them before this script loads.');
    return;
  }

  ShopifySettings.enable_next_day_countdown = window.theme.settings.enableNextDayCountdown;
  ShopifySettings.countdown_cutoff_time = window.theme.settings.countdownCutoffTime;
  ShopifySettings.bank_holidays_list = window.theme.settings.bankHolidaysList;

  console.log('ShopifySettings loaded:', ShopifySettings);

  if (ShopifySettings.enable_next_day_countdown) {
    var currentDate = new Date();
	var currentDateWithCutoff = new Date();
    var orderByDate = new Date();
    var deliveryDate = new Date();

    var cutoff_time_parts = ShopifySettings.countdown_cutoff_time.split(':');
    var cutoff_hour = parseInt(cutoff_time_parts[0], 10);
    var cutoff_minute = parseInt(cutoff_time_parts[1], 10);

    var remaining = 0;
    var bankHolidays = ShopifySettings.bank_holidays_list.split('\n').filter(Boolean);
    var deliveryDays = 1;

    orderByDate.setHours(cutoff_hour);
    orderByDate.setMinutes(cutoff_minute);
    orderByDate.setSeconds(0);
    orderByDate.setMilliseconds(0);
	
	currentDateWithCutoff.setHours(cutoff_hour);
    currentDateWithCutoff.setMinutes(cutoff_minute);
    currentDateWithCutoff.setSeconds(0);
    currentDateWithCutoff.setMilliseconds(0);	

    getDates();

    var tick = setInterval(function() {
      currentDate = new Date();
      remaining = orderByDate - currentDate;

      if (remaining <= 0) {
        getDates();
        remaining = orderByDate - currentDate;
      }

      const countdownEl = document.getElementById('deliveryCountdown');
      if (countdownEl) {
        countdownEl.classList.remove("hide-countdown");
        updateDisplayNative(timeRemaining(remaining));
      }

      // Check if current time is after the cutoff time but before midnight
      // The orderByDate is adjusted in getDates() if the cutoff has passed
      const sameDayLabel = document.querySelector("#deliveryCountdown .gen-label-2.same-day-dispatch");
      const tomorrowLabel = document.querySelector("#deliveryCountdown .gen-label-2.tomorrow-dispatch");

      const isAfterCutoff = currentDate.getTime() > currentDateWithCutoff.getTime();
      const isBeforeMidnight = currentDate.getHours() < 24 || (currentDate.getHours() === 23 && currentDate.getMinutes() < 60);
	  
	  
	  console.log(currentDate.getTime());
	  console.log(orderByDate.getTime());
	  console.log(isAfterCutoff);
	  console.log(isBeforeMidnight);

      if (isAfterCutoff && isBeforeMidnight) {
		  console.log("qwerty1");
          if (tomorrowLabel) {
              tomorrowLabel.style.display = 'flex';
          }
          if (sameDayLabel) {
              sameDayLabel.style.display = 'none';
          }
      } else {
		  console.log("qwerty2");
          if (sameDayLabel) {
              sameDayLabel.style.display = 'flex';
          }
          if (tomorrowLabel) {
              tomorrowLabel.style.display = 'none';
          }
      }

    }, 1000);
  }

  function updateDisplayNative(remaining) {
    const hoursEl = document.querySelector(".delivery-countdown-hours-number");
    const minutesEl = document.querySelector(".delivery-countdown-minutes-number");
    const secondsEl = document.querySelector(".delivery-countdown-seconds-number");
    const deliveryCountdownEl = document.getElementById('deliveryCountdown');
    const deliveryDateDisplayEl = document.getElementById('deliveryDateDisplay');		

    if (hoursEl) hoursEl.textContent = remaining.hours;
    if (minutesEl) minutesEl.textContent = pad(remaining.mins);
    if (secondsEl) secondsEl.textContent = pad(remaining.seconds);

    const optionsWeekday = { weekday: 'long' };
    const optionsDate = { day: 'numeric', month: 'long' };
    const deliveryDayOfWeek = new Intl.DateTimeFormat('en-GB', optionsWeekday).format(deliveryDate);
    const deliveryDayAndMonth = new Intl.DateTimeFormat('en-GB', optionsDate).format(deliveryDate);

    if (deliveryDateDisplayEl) {
      deliveryDateDisplayEl.textContent = `${deliveryDayOfWeek}, ${getOrdinalNum(deliveryDate.getDate())} ${deliveryDayAndMonth.split(' ')[1]}`;
    }
  }

  function getOrdinalNum(n) {
    return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
  }

  function getDates() {
    if (currentDate.getTime() > orderByDate.getTime()) {
      orderByDate = addDay(orderByDate);
    }

    orderByDate = nextValidDate(orderByDate);

    deliveryDate = new Date(orderByDate.getTime());
    deliveryDate.setDate(deliveryDate.getDate() + deliveryDays);
    deliveryDate = nextValidDate(deliveryDate);
  }

  function nextValidDate(date) {
    let changed = false;
/* 
    do {
      changed = false;	  
	  
      if (date.getDay() === 0) {
        date = addDay(date, 1);
        changed = true;
      } else if (date.getDay() === 6) {
        date = addDay(date, 2);
        changed = true;
      }

      let tmpDate = date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
      if (bankHolidays.includes(tmpDate)) {
        date = addDay(date, 1);
        changed = true;
      }
    } while (changed); */

    return date;
  }

  function addDay(date, days = 1) {
    let newDate = new Date(date.getTime());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }

  function pad(num) {
    var s = num + "";
    let size = 2;
    while (s.length < size) s = "0" + s;
    return s;
  }

  function timeRemaining(time) {
    time = time / 1000;
    var remaining = {
      hours: 0,
      mins: 0,
      seconds: 0,
      ms: time
    };
    remaining.hours = Math.floor((time % 86400) / 3600);
    remaining.mins = Math.floor((time % 3600) / 60);
    remaining.seconds = Math.floor((time % 60));
    return remaining;
  }
}